import styled from "styled-components";
import { isMobile } from "react-device-detect";

type HeaderWrapperProps = {
  children: React.ReactNode;
  mobile?: boolean;
};

const HeaderWrapper = ({ children }: HeaderWrapperProps) => {
  return (
    <HeaderStyledHeaderWrapper>
      <HeaderWidthContainer mobile={isMobile}>{children}</HeaderWidthContainer>
    </HeaderStyledHeaderWrapper>
  );
};

const HeaderStyledHeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  max-width: 100%;
`;

const HeaderWidthContainer = styled.div<HeaderWrapperProps>`
  position: "relative";
  width: ${isMobile ? "100%" : "77%"};
  max-width: 100%;
`;

export default HeaderWrapper;
